import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect, PropsFromRedux } from './MobileActionsContainer';
import { SearchDecisionWatcher } from '../search-decision-watcher/SearchDecisionWatcher';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';

type Props = PropsFromRedux;

export class RawMobileActions extends React.Component<Props> {
  openFilter = () => {
    const { openFilter } = this.props;
    doctrineAnalytics('Search FilterOpened');
    openFilter();
  };

  render() {
    const {
      displayed,
      hasFilters,
      selectedFiltersLength,
      totalHits,
      type,
      isSearchLoading,
    } = this.props;

    return (
      displayed && (
        <div className="mobile-actions hide-for-large">
          {!isSearchLoading && totalHits > 0 && type === 'arret' && (
            <SearchDecisionWatcher />
          )}

          {hasFilters && (
            <button
              type="button"
              className="button small hollow mobile-actions__button"
              onClick={this.openFilter}
            >
              <i className="material-icons icons__filter_list" />
              <span>
                <FormattedMessage id="search/components/mobile-actions/MobileActions.tsx/1" />
              </span>
              {selectedFiltersLength > 0 && (
                <span className="mobile-actions__number">
                  {'\u00A0'}
                  <FormattedMessage id="search/components/mobile-actions/MobileActions.tsx/2" />
                  {selectedFiltersLength}
                  <FormattedMessage id="search/components/mobile-actions/MobileActions.tsx/3" />
                </span>
              )}
            </button>
          )}
        </div>
      )
    );
  }
}

export const MobileActions = Connect(RawMobileActions);
